/*global Sly */
jQuery(function ($) {
	'use strict';

	// Detect IE.
	// Feature detection of "transform-style: preserve-3d" doesn't work, so this
	// is the only way how to fall back to a 2D front page featured_nut in IE that
	// doesn't have a full support of 3D transforms across the board.
	document.getElementsByTagName('html')[0].className += ' ' +
		(~window.navigator.userAgent.indexOf('MSIE') ? 'ie' : 'no-ie');

	// ==========================================================================
	//   Header featured_nut
	// ==========================================================================
  
  var $featured_nut = $('#tab-featured-1');
  var $frame = $featured_nut.find('.frame'); window.frr = $frame;
  var sly = new Sly($frame, {
    horizontal: 1,
    itemNav: 'forceCentered',
    activateMiddle: 1,
    smart: 1,
    activateOn: 'click',
    mouseDragging: 1,
    touchDragging: 1,
    releaseSwing: 1,
    startAt: 2,
    scrollBar: $featured_nut.find('.scrollbar'),
    scrollBy: 1,
    pagesBar: $featured_nut.find('.pages'),
    activatePageOn: 'click',
    speed: 200,
    moveBy: 600,
    elasticBounds: 1,
    dragHandle: 1,
    dynamicHandle: 1,
    clickBar: 1,
  }).init();
  
  $('ul.tabs li').click(function(){
    
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
    
      
    
    if(tab_id=='tab-1')
    {
      var $featured_nut = $('#tab-featured-1');
      var $frame = $featured_nut.find('.frame'); window.frr = $frame;
      var sly = new Sly($frame, {
          horizontal: 1,
          itemNav: 'forceCentered',
          activateMiddle: 1,
          smart: 1,
          activateOn: 'click',
          mouseDragging: 1,
          touchDragging: 1,
          releaseSwing: 1,
          startAt: 2,
          scrollBar: $featured_nut.find('.scrollbar'),
          scrollBy: 2,
          pagesBar: $featured_nut.find('.pages'),
          activatePageOn: 'click',
          speed: 200,
          moveBy: 600,
          elasticBounds: 1,
          dragHandle: 1,
          dynamicHandle: 1,
          clickBar: 1,
      }).init();
    } 
  
  	if(tab_id=='tab-2')
    {
      var $featured_new_product = $('#tab-featured-2');
      var $frame_new_product = $featured_new_product.find('.frame'); window.frr = $frame_new_product;
      var sly = new Sly($frame_new_product, {
          horizontal: 1,
          itemNav: 'forceCentered',
          activateMiddle: 1,
          smart: 1,
          activateOn: 'click',
          mouseDragging: 1,
          touchDragging: 1,
          releaseSwing: 1,
          startAt: 2,
          scrollBar: $featured_new_product.find('.scrollbar'),
          scrollBy: 1,
          pagesBar: $featured_new_product.find('.pages'),
          activatePageOn: 'click',
          speed: 200,
          moveBy: 600,
          elasticBounds: 1,
          dragHandle: 1,
          dynamicHandle: 1,
          clickBar: 1,
      }).init();
    }
    
    if(tab_id=='tab-3')
    {
      var $featured_on_sale = $('#tab-featured-3');
      var $frame_on_sale = $featured_on_sale.find('.frame'); window.frr = $frame_on_sale;
      var sly = new Sly($frame_on_sale, {
          horizontal: 1,
          itemNav: 'forceCentered',
          activateMiddle: 1,
          smart: 1,
          activateOn: 'click',
          mouseDragging: 1,
          touchDragging: 1,
          releaseSwing: 1,
          startAt: 2,
          scrollBar: $featured_on_sale.find('.scrollbar'),
          scrollBy: 1,
          pagesBar: $featured_on_sale.find('.pages'),
          activatePageOn: 'click',
          speed: 200,
          moveBy: 600,
          elasticBounds: 1,
          dragHandle: 1,
          dynamicHandle: 1,
          clickBar: 1,
      }).init();
    }
	});	
});